// Copyright (c) Microsoft. All rights reserved.

export enum AlertType {
    Success = 'success',
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
}
